import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "catalyst/link";
export function QuickstartNavigation({ agent, active, }) {
    const basePath = `/quickstart/${agent}`;
    const sections = [
        { id: "setup", label: "Настройка агента", href: basePath },
        {
            id: "subscriptions",
            label: "Подключение подписки",
            href: `${basePath}/subscriptions`,
        },
    ];
    return (_jsx("nav", { "aria-label": `Разделы ${agent === "codex" ? "Codex" : "Claude Code"}`, className: "overflow-x-auto border-b border-zinc-950/10 dark:border-white/10", children: _jsx("div", { className: "flex min-w-max items-center gap-4 sm:gap-6", children: sections.map((section) => {
                const isActive = section.id === active;
                return (_jsx(Link, { href: section.href, "aria-current": isActive ? "page" : undefined, className: isActive
                        ? "relative pb-3 text-xs/5 font-medium text-zinc-950 after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:rounded-full after:bg-zinc-950 sm:text-sm/6 dark:text-white dark:after:bg-white"
                        : "pb-3 text-xs/5 font-medium text-zinc-500 transition-colors hover:text-zinc-800 sm:text-sm/6 dark:text-zinc-400 dark:hover:text-zinc-200", children: section.label }, section.id));
            }) }) }));
}
